<template>
  <div class="d-flex" id="wrapper">
    <Header @menu_v="menu_status"/>
    <div id="page-content-wrapper">
      <location :menu_status="menu_visible" />
      <slot />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Location from '@/components/Location'

export default {
  name: 'DefaultLayout',
  data() {
    return {
      menu_visible: true,
    }
  },
  components: {
    Header,
    Location
  },
  computed: {
    name: function() {
      return this.$route.name ? this.$route.name : ''
    }
  },
  methods: {
    menu_status(v) {
      this.menu_visible = v
      console.log(this.menu_visible)
    }
  }
}
</script>
